module.exports = __webpack_public_path__ + "static/media/hero-virtual-showroom.f305e89a.jpg";